export enum Role {
  Administrator = 'Administrator',
  GAdministrator = 'Group Administrator',
  CAdministrator = 'Client Administrator',
  Valuer = 'Valuer',
  Viewer = 'Viewer',
  Editor = 'Editor',
}
